<div class="row">
    <div class="col-12 ml-auto mr-auto">
        <div class="dash-card">
            <!-- <app-back-button [defaultRoute]="getBackLink()"
                [useDefaultRoute]="true" [step]="9"></app-back-button> -->

            <ng-container *ngIf="loading">

                <div class="dash-card-header">
                    <ngx-skeleton-loader
                        [theme]="{width: '111px',height: '27px'}">
                    </ngx-skeleton-loader>
                </div>

                <div class="dash-card-body">
                    <div class="row">

                        <div class="col-12">
                            <ngx-skeleton-loader
                                [theme]="{height: '44px',marginBottom:'24px'}">
                            </ngx-skeleton-loader>
                        </div>

                        <div class="col-3">
                            <ngx-skeleton-loader
                                [theme]="{height: '44px',marginBottom:'24px'}">
                            </ngx-skeleton-loader>
                        </div>

                        <div class="col-3">
                            <ngx-skeleton-loader
                                [theme]="{height: '44px',marginBottom:'24px'}">
                            </ngx-skeleton-loader>
                        </div>

                        <div class="col-12">
                            <ngx-skeleton-loader
                                [theme]="{width: '165px',height: '44px',marginBottom:'24px'}">
                            </ngx-skeleton-loader>
                        </div>

                        <div class="col-12">
                            <ngx-skeleton-loader [theme]="{height: '500px'}">
                            </ngx-skeleton-loader>
                        </div>


                        <div class="col-12">

                            <ngx-skeleton-loader
                                [theme]="{width: '200px',height: '40px'}">
                            </ngx-skeleton-loader>

                            <div class="row">
                                <div class="col-12"
                                    *ngFor="let number of [0,1,2,3,4,5]">
                                    <ngx-skeleton-loader
                                        [theme]="{width: '100%',height: '25px'}">
                                    </ngx-skeleton-loader>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="row">
                        <div
                            class="col-12 text-right d-flex align-items-center justify-content-end">
                            <ngx-skeleton-loader
                                [theme]="{width: '130px',height: '40px',marginRight: '16px'}">
                            </ngx-skeleton-loader>

                            <ngx-skeleton-loader
                                [theme]="{width: '130px',height: '40px'}">
                            </ngx-skeleton-loader>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="!loading">
                <div
                    class="dash-card-header d-flex align-items-center justify-content-between">
                    <h2 *ngIf="!id"><span>Criar template minuta</span></h2>

                    <h2 *ngIf="id">Editar template minuta <span>{{title}}</span>
                    </h2>

                    <app-button *ngIf="showResume" [inverted]="true"
                        (onClick)="previewPrint()" [loading]="previewing"
                        [disabled]="getDisabled() || previewing || inactiveContentVariables.length">
                        <svg-icon src="assets/images/icon-data-view-alt.svg"
                            class="mr-2"></svg-icon>
                        Visualizar impressão
                    </app-button>
                </div>

                <div class="dash-card-body">
                    <app-warning-bar class="mb-3"
                        *ngIf="inactiveContentVariables.length"
                        message="Este template possui variáveis inválidas no conteúdo. Corrija ou remova essas variáveis para avançar."
                        [items]="inactiveContentVariables">
                    </app-warning-bar>

                    <div class="row mb-5" *ngIf="showResume">
                        <div class="col-lg-4">
                            <p class="title">
                                Nome da minuta
                            </p>
                            <p class="label">
                                {{form.controls.name.value || '-'}}
                            </p>
                        </div>

                        <div class="col-lg-4">
                            <p class="title">
                                Tipo de documento
                            </p>
                            <p class="label">
                                {{renderType(form.controls.type.value)}}
                            </p>
                        </div>

                        <div class="col-lg-4">
                            <p class="title">
                                Validade
                            </p>
                            <p class="label">
                                {{form.controls.final_date.value || '-'}}
                            </p>
                        </div>

                        <div class="col-12 mt-4">
                            <p class="title">
                                Testemunhas
                            </p>
                            <p class="label">
                                {{renderWitnesses()}}
                            </p>
                        </div>
                    </div>

                    <form [formGroup]="form">
                        <div class="row" *ngIf="showForm">
                            <div class="col-12 col-lg-4">
                                <app-input [group]="form" controlName="name"
                                    label="Nome da minuta" placeholder="Digite">
                                </app-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-4">
                                <app-select [items]="typeItems" [group]="form"
                                    controlName="type" label="Tipo de documento"
                                    placeholder="Selecione">
                                </app-select>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-4">
                                <app-masked-input [group]="form"
                                    controlName="final_date" mask="00/00/0000"
                                    label="Validade" placeholder="dd/mm/aaaa">
                                </app-masked-input>

                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-6">
                                <app-select [items]="applicableItems"
                                    [multiple]="true" [group]="form"
                                    controlName="assignees" label="Papéis"
                                    placeholder="Selecione">
                                </app-select>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-6">
                                <app-select [items]="witnessItems"
                                    [multiple]="true" [group]="form"
                                    controlName="witnesses" label="Testemunhas"
                                    placeholder="Selecione">
                                </app-select>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>
                        </div>


                        <div class="row">
                            <div [class.d-none]="loading" class="w-100">
                                <quill-editor [modules]="quillModules"
                                    class="editor-container"
                                    [class.readonly]="!showForm"
                                    [readOnly]="!showForm"
                                    placeholder=""
                                    formControlName="content"
                                    (onEditorCreated)="onEditorCreated($event)">
                                </quill-editor>
                            </div>

                        </div>

                        <app-spacer [bottom]="32"></app-spacer>

                        <ng-container *ngIf="showForm">
                            <div class="variables-header">
                                <h6 class="mb-0">Variáveis disponíveis</h6>
                                <div class="variables-legend">
                                    <span class="legend-item">
                                        <span class="legend-swatch"
                                            aria-hidden="true"></span>
                                        Cadastro
                                    </span>
                                    <span class="legend-item">
                                        <span class="legend-swatch smart"
                                            aria-hidden="true"></span>
                                        SMART
                                    </span>
                                </div>
                            </div>
                            <p class="mb-3 pl-2 text-muted">
                                Clique nas variáveis para inserir no texto.
                            </p>

                            <app-tabs class="variables-tabs" [tabs]="variableTabs"
                                [currentTab]="variablesTabIndex"
                                [dashboardTab]="true"
                                (onChangeTab)="onVariablesTab($event)">
                            </app-tabs>

                            <form [formGroup]="searchForm"
                                class="variables-search">
                                <app-input [group]="searchForm"
                                    controlName="search">
                                </app-input>
                            </form>

                            <ng-container *ngIf="showVariableSkeleton">
                                <table class="bordered">
                                    <thead>
                                        <tr>
                                            <th>
                                                <ngx-skeleton-loader
                                                    [theme]="{height: '15px', width: '80px', marginBottom: '0'}">
                                                </ngx-skeleton-loader>
                                            </th>
                                            <th>
                                                <ngx-skeleton-loader
                                                    [theme]="{height: '15px', width: '100px', marginBottom: '0'}">
                                                </ngx-skeleton-loader>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let row of [0,1,2,3,4]">
                                            <td>
                                                <ngx-skeleton-loader
                                                    [theme]="{height: '15px', width: '140px', marginBottom: '0'}">
                                                </ngx-skeleton-loader>
                                            </td>
                                            <td>
                                                <ngx-skeleton-loader
                                                    [theme]="{height: '24px', width: '160px', marginBottom: '0'}">
                                                </ngx-skeleton-loader>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </ng-container>

                            <ng-container
                                *ngIf="!showVariableSkeleton && activeVariableRows.length > 0">
                                <table class="bordered">
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                            <th>Variável</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr *ngFor="let item of activeVariableRows">
                                            <td>
                                                {{item.name}}
                                            </td>
                                            <td>
                                                <div class="tag"
                                                    [class.smart]="item.type === 'fs_engine'"
                                                    (mousedown)="$event.preventDefault()"
                                                    (click)="insertVariable(item.variable, item.type)"
                                                    style="cursor: pointer;">
                                                    {{item.variable}}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div class="dash-card-pagination">
                                    <app-pagination
                                        [data]="activeVariableRows"
                                        [count]="variablesTabIndex === 0 ? count : witnessCount"
                                        [show]="!loading"
                                        [offset]="variablesTabIndex === 0 ? offset : witnessOffset"
                                        [currentPageFromApi]="variablesTabIndex === 0 ? variablesPage : witnessPage"
                                        (onPageChange)="changePageData($event)"
                                        [dashPagination]="true"
                                        [resultsPerPage]="results_per_page">
                                    </app-pagination>
                                </div>
                            </ng-container>

                            <div
                                *ngIf="!showVariableSkeleton && activeVariableRows.length === 0"
                                class="text-center py-4">
                                <p class="text-muted">{{ emptyVariablesMessage }}</p>
                            </div>
                        </ng-container>


                        <ng-container *ngIf="showResume">
                            <h6 class="mb-3 pl-2">Assinantes</h6>
                            <table class="bordered"
                                *ngIf="selectedAssignees.length > 0">
                                <thead>
                                    <tr>
                                        <th>Papel</th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr
                                        *ngFor="let item of selectedAssignees; let i = index">
                                        <td>
                                            {{item.label}}
                                        </td>
                                        <td
                                            style="width: 50px; text-align: center;">
                                            <button class="dash-item-button"
                                                (click)="removeAssignee(i)">
                                                <svg-icon
                                                    src="assets/images/icon-trash.svg"></svg-icon>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div *ngIf="selectedAssignees.length === 0"
                                class="text-center py-4">
                                <p class="text-muted">Nenhum assinante
                                    adicionado</p>
                            </div>
                        </ng-container>

                        <app-spacer [bottom]="48"></app-spacer>

                        <div class="row">
                            <div class="col-12  d-flex justify-content-between">
                                <app-button (onClick)="redirect()"
                                    class="add-button" [outline]="true">
                                    Cancelar
                                </app-button>

                                <div class="d-flex align-items-center">
                                    <app-button (onClick)="handleBack()"
                                        class="add-button" [outline]="true">
                                        Voltar
                                    </app-button>
                                    <app-spacer [right]="16"></app-spacer>

                                    <app-button (onClick)="createTemplate(true)"
                                        class="add-button" [outline]="true"
                                        [disabled]="getDisabled()">
                                        Salvar rascunho
                                    </app-button>
                                    <app-spacer [right]="16"></app-spacer>

                                    <app-button (onClick)="handleNext()"
                                        [disabled]="getDisabled() || inactiveContentVariables.length"
                                        class="add-button">
                                        {{showResume ? 'Salvar modelo' :
                                        'Avançar' }}
                                    </app-button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </ng-container>
        </div>
    </div>
</div>